// extracted by mini-css-extract-plugin
export default {"root":"mHPJDh","icon":"_IXl7x","visible":"gJIPb9","hidden":"gWrmGX"};